import React from "react";
import { useI18n } from "../context/I18nContext";

export const DashboardNav = ({ items, active, onChange }) => {
  const { t } = useI18n();
  return (
    <div className="sticky top-16 z-40 bg-white/90 backdrop-blur-md border-b border-gray-200" data-testid="dashboard-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex gap-1 overflow-x-auto no-scrollbar py-2">
          {items.map((it) => {
            const isActive = active === it.key;
            const Icon = it.icon;
            return (
              <button
                key={it.key}
                data-testid={`nav-${it.key}`}
                onClick={() => onChange(it.key)}
                className={`flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-md text-sm font-semibold transition-all ${
                  isActive
                    ? "bg-emerald-800 text-white shadow-sm"
                    : "text-emerald-800 hover:bg-emerald-50"
                }`}
              >
                {Icon && <Icon size={18} weight={isActive ? "fill" : "bold"} />}
                {t(it.label)}
                {it.badge > 0 && (
                  <span data-testid={`nav-badge-${it.key}`} className={`ml-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center ${isActive ? "bg-white text-red-600" : "bg-red-500 text-white"}`}>{it.badge}</span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
